import cookie from 'cookie';

export const getCookies = () =>
  typeof document !== 'undefined' ? cookie.parse(document.cookie) : {};
